import React from "react";

export const NoIcon = (props) => {

    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="#f80"
        stroke="#f80"
        viewBox="0 0 1920 1920"
      >
        <path
          fillRule="evenodd"
          d="M213.333 960c0-167.36 56-321.707 149.44-446.4L1406.4 1557.227c-124.693 93.44-279.04 149.44-446.4 149.44-411.627 0-746.667-335.04-746.667-746.667m1493.334 0c0 167.36-56 321.707-149.44 446.4L513.6 362.773c124.693-93.44 279.04-149.44 446.4-149.44 411.627 0 746.667 335.04 746.667 746.667M960 0C429.76 0 0 429.76 0 960s429.76 960 960 960 960-429.76 960-960S1490.24 0 960 0"
        ></path>
      </svg>
    )
}
export const UnlockIcon = () => {

    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        stroke="#fff"
        viewBox="-1.44 -1.44 26.88 26.88"
      >
        <rect
          width="26.88"
          height="26.88"
          x="-1.44"
          y="-1.44"
          fill="#f5873d"
          strokeWidth="0"
          rx="2.688"
        ></rect>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 14v2M8.12 5.025A4.002 4.002 0 0116 6v3M7 21h10a2 2 0 002-2v-8a2 2 0 00-2-2H7a2 2 0 00-2 2v8a2 2 0 002 2z"
        ></path>
      </svg>
    )
}
export const EditIcon = () => {

    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="#4f4f4f"
        stroke="#4f4f4f"
        viewBox="-2.4 -2.4 28.8 28.8"
      >
        <rect
          width="28.8"
          height="28.8"
          x="-2.4"
          y="-2.4"
          fill="#d6d6d6"
          strokeWidth="0"
          rx="3.456"
        ></rect>
        <path d="M20.7 5.2a1.024 1.024 0 010 1.448l-2.626 2.628-3.35-3.35L17.35 3.3a1.024 1.024 0 011.448 0zm-4.166 5.614l-3.35-3.35-8.509 8.511L3 21l5.025-1.675z"></path>
      </svg>
    )
}
export const DeleteIcon = () => {

    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="#fff"
        stroke="#fff"
        version="1.1"
        viewBox="-121.22 -121.22 660.44 660.44"
        xmlSpace="preserve"
      >
        <rect
          width="660.44"
          height="660.44"
          x="-121.22"
          y="-121.22"
          fill="#d21404"
          strokeWidth="0"
          rx="79.253"
        ></rect>
        <g>
          <path d="M265.616 38V0H152.384v38H69v60h280V38h-83.384zm-83.232-8h53.232v8h-53.232v-8z"></path>
          <path d="M109 418L309 418 328.016 128 89.984 128z"></path>
        </g>
      </svg>
    )
}
export const PlusRoundedIcon = () => {

    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        fill="#fff"
        stroke="#fff"
        viewBox="0 -0.5 21 21"
      >
        <g>
          <g fill="none" fillRule="evenodd" strokeWidth="0">
            <g fill="#fff" transform="translate(-419 -520)">
              <g transform="translate(56 160)">
                <path d="M374.55 369h3.15v2h-3.15v3h-2.1v-3h-3.15v-2h3.15v-3h2.1v3zm-1.05 9c-4.632 0-8.4-3.589-8.4-8s3.768-8 8.4-8c4.632 0 8.4 3.589 8.4 8s-3.768 8-8.4 8h0zm0-18c-5.8 0-10.5 4.477-10.5 10s4.7 10 10.5 10 10.5-4.477 10.5-10-4.7-10-10.5-10h0z"></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
}